var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumnetTypeManagment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 2050 2050",
    "data-name": "Layer 3",
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#404e63;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.7,1062.9H465.1a45.1,45.1,0,0,1-45-45V600.3a45,45,0,0,1,45-45H882.7a44.9,44.9,0,0,1,45,45v417.6A45,45,0,0,1,882.7,1062.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.9,728.8H1091.2a45,45,0,0,1,0-90h493.7a45,45,0,0,1,0,90Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.9,984.1H1091.2a45,45,0,0,1,0-90h493.7a45,45,0,0,1,0,90Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.9,1239.4H465.1a45,45,0,1,1,0-90H1584.9a45,45,0,0,1,0,90Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.9,1494.7H465.1a45,45,0,0,1,0-90H1584.9a45,45,0,0,1,0,90Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.6,926.9a45,45,0,0,1-45-45V759.5a45,45,0,0,1,90,0V881.9A45.1,45.1,0,0,1,671.6,926.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M753,792.9H594.8a45,45,0,0,1,0-90H753a45,45,0,0,1,0,90Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumnetTypeManagment);
export default __webpack_public_path__ + "static/media/DocumnetTypeManagment.249bbc63a49b95cb5729f01a9b5b943b.svg";
export { ForwardRef as ReactComponent };